import { render, staticRenderFns } from "./InputComponent.vue?vue&type=template&id=474a22b0&scoped=true"
import script from "./InputComponent.vue?vue&type=script&lang=js"
export * from "./InputComponent.vue?vue&type=script&lang=js"
import style0 from "./InputComponent.vue?vue&type=style&index=0&id=474a22b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474a22b0",
  null
  
)

export default component.exports